import { jsx as _jsx } from "react/jsx-runtime";
import ErrorBoundary from './components/errorBoundary/ErrorBoundary';
import ConfigReceiver from './components/configReceiver/ConfigReceiver';
import { AppRouter } from './AppRoutes';
const App = () => {
    return (_jsx(ErrorBoundary, { children: _jsx(ConfigReceiver, { children: _jsx(AppRouter, {}) }) }));
};
export default App;
